import MuiTypography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const Typography = styled(MuiTypography)(() => ({
  color: 'var(--primary)',
}));

export default Typography;
